import {GridWidgetFilter} from './grid-widget-filter';
import { pdsI18n } from '../../../src/pds-i18n';
import {RestArgument} from './rest-argument';
export class DateFilter extends GridWidgetFilter {
  comparator = '=';

  //These dates are assumed to be created from the pds-date-widget,
  //which creates the date objects in the local time zone.
  searchValueDate: Date | null | undefined;
  searchValueDate2: Date | null | undefined;

  getTagName(): string {
    return 'pds-gw-date-filter';
  }

  preFilterUpdate(): void {
  }

  isBlank(): boolean {
    if (this.comparator === 'range') {
      return (this.searchValueDate == null || isNaN(this.searchValueDate.getTime())) &&
        (this.searchValueDate2 == null || isNaN(this.searchValueDate2.getTime()));
    }

    //Nothing there is blank, or if they put in something that isn't a date it will be blank.
    return this.searchValueDate == null || isNaN(this.searchValueDate.getTime());
  }

  internalPassesFilter(dataFromDataRow): boolean {
    let regexFromFilter;
    // if it's undefined or null then do not pass
    if (dataFromDataRow == null || !(dataFromDataRow instanceof Date)) {
      return false;
    }

    let dataFromRowOffset = dataFromDataRow.getTimezoneOffset();

    //This truncates any time that may be associated with the date from the dataRow object.
    dataFromDataRow = new Date(dataFromDataRow.getFullYear(), dataFromDataRow.getMonth(), dataFromDataRow.getDate());
    if (dataFromDataRow.getTimezoneOffset() !== dataFromRowOffset) {
      console.error('The date from the data being filtered is not in the local time zone.  The grid widget does not support that at this time.');
    }

    if (this.comparator !== 'range' && this.searchValueDate == null) {
      //This case will not be hit in normal operation, but it's possible this functions does get called independently.
      //This check here allows us to ensure this.searchValueDate is not null or undefined below.
      return true;
    }

    switch (this.comparator) {
      case '~':
      case '=':
        return dataFromDataRow.getTime() === this.searchValueDate!.getTime();
      case '>':
        return dataFromDataRow.getTime() > this.searchValueDate!.getTime();
      case '>=':
        return dataFromDataRow.getTime() >= this.searchValueDate!.getTime();
      case '<':
        return dataFromDataRow.getTime() < this.searchValueDate!.getTime();
      case '<=':
        return dataFromDataRow.getTime() <= this.searchValueDate!.getTime();
      case 'range':
        let val1 = (this.searchValueDate == null || isNaN(this.searchValueDate.getTime()) || dataFromDataRow.getTime() >= this.searchValueDate.getTime());
        let val2 = (this.searchValueDate2 == null || isNaN(this.searchValueDate2.getTime()) || dataFromDataRow.getTime() <= this.searchValueDate2.getTime());
        return val1 && val2;
      default:
        throw 'The comparator is not set in the DateFilter or is not supported: ' + this.comparator;
    }
  }

  setQuickSearchValue(text: string): boolean {
    this.searchValueDate = pdsI18n.deLocalizeDate(text);

    if (this.searchValueDate == null && typeof text === 'string') {
      let today = new Date();
      if (text.toLowerCase() === pdsI18n.getText('global|Today').toLowerCase()) {
        this.searchValueDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      } else if (text.toLowerCase() === pdsI18n.getText('global|Tomorrow').toLowerCase()) {
        this.searchValueDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
      } else if (text.toLowerCase() === pdsI18n.getText('global|Yesterday').toLowerCase()) {
        this.searchValueDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      }
    }

    this.comparator = '~';
    return this.searchValueDate != null;
  }

  getRestArguments(): Array<RestArgument> {
    if (this.isBlank()) {
      return [];
    }
    if (this.comparator === 'range') {
      let restArgs: Array<RestArgument> = [];

      if (this.searchValueDate instanceof Date) {
        restArgs.push(new RestArgument(
          this.dataField.id,
          '>=',
          this.searchValueDate,
          pdsI18n.getMmDdYyyyDateString(this.searchValueDate)
        ));
      }

      if (this.searchValueDate2 instanceof Date) {
        restArgs.push(new RestArgument(
          this.dataField.id,
          '<=',
          this.searchValueDate2,
          pdsI18n.getMmDdYyyyDateString(this.searchValueDate2)
        ));
      }

      return restArgs;
    } else {
      return [
        new RestArgument(
          this.dataField.id,
          this.comparator === '~' ? '=' : this.comparator,
          this.searchValueDate,
          pdsI18n.getMmDdYyyyDateString(this.searchValueDate)
        )
      ];
    }
  }

  getTagText(): string {
    if (this.comparator === 'range') {
      return pdsI18n.localizeDate(this.searchValueDate) + ' - ' + pdsI18n.localizeDate(this.searchValueDate2);
    } else {
      return this.comparator + ' ' + pdsI18n.localizeDate(this.searchValueDate);
    }
  }

  getPersistenceObject(): Object | undefined {
    let state = {
      comparator: this.comparator,
      searchValueDate: pdsI18n.getJsonDate(this.searchValueDate),
      searchValueDate2: pdsI18n.getJsonDate(this.searchValueDate2)
    };
    return state;
  }

  restoreFromPersistenceObject(value: Object): void {
    let state = <any>value;
    this.comparator = state.comparator;
    this.searchValueDate = pdsI18n.parseJsonDate(state.searchValueDate);
    this.searchValueDate2 = pdsI18n.parseJsonDate(state.searchValueDate2);
  }
}
